/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordChangeRequestBody
 */
export interface PasswordChangeRequestBody {
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeRequestBody
     */
    currentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeRequestBody
     */
    newPassword: string;
}

export function PasswordChangeRequestBodyFromJSON(json: any): PasswordChangeRequestBody {
    return PasswordChangeRequestBodyFromJSONTyped(json, false);
}

export function PasswordChangeRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordChangeRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currentPassword': json['current_password'],
        'newPassword': json['new_password'],
    };
}

export function PasswordChangeRequestBodyToJSON(value?: PasswordChangeRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'current_password': value.currentPassword,
        'new_password': value.newPassword,
    };
}

